import React from 'react'
import { useTranslation } from 'react-i18next';

const NoDiscussionSelected = () => {
    const { t } = useTranslation();
    return (
        <div className='d-flex flex-column align-items-center justify-content-center' style={{height: '250px'}}>
            <span className="fa-stack fa-2x">
                <i className="fas fa-envelope fa-stack-1x"></i>
                <i className="fas fa-ban fa-stack-2x text-danger"></i>
            </span>
            <h6>{t("Aucune discussion sélectionnée")}</h6>
        </div>
    )
}

export default NoDiscussionSelected